var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmbientSound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13585_2548)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.167 8.16675V14.5001H10.167V8.16675H11.167Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83301 8.16675V14.5001H4.83301V8.16675H5.83301Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 9.5V15.8333H7.5V9.5H8.5Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.40548 0.196758C6.32513 0.103114 7.25386 0.229369 8.11513 0.565117C8.9764 0.900866 9.74555 1.43649 10.3592 2.12785C10.8861 2.72157 11.2854 3.41553 11.5341 4.16656H12.0003C12.8802 4.16759 13.7335 4.47127 14.416 5.02663C15.0984 5.58199 15.569 6.35521 15.7489 7.2165C15.9287 8.07779 15.8067 8.97472 15.4035 9.75674C15.0002 10.5388 14.3402 11.1582 13.5343 11.5112L13.0763 11.7118L12.6751 10.7958L13.1331 10.5952C13.7288 10.3343 14.2166 9.87644 14.5147 9.29843C14.8127 8.72042 14.9029 8.05747 14.77 7.42086C14.6371 6.78425 14.2892 6.21274 13.7848 5.80226C13.2804 5.39184 12.6503 5.16738 12 5.16656C11.9999 5.16656 12.0001 5.16656 12 5.16656H11.1603C10.9324 5.16656 10.7332 5.01232 10.6762 4.79157C10.4847 4.04997 10.1197 3.3645 9.61127 2.79166C9.10284 2.21882 8.46555 1.77502 7.75192 1.49683C7.0383 1.21863 6.26878 1.11402 5.50679 1.19161C4.7448 1.26921 4.01216 1.52678 3.36925 1.9431C2.72635 2.35942 2.19159 2.92258 1.80906 3.58614C1.42653 4.2497 1.20717 4.99468 1.16907 5.75966C1.13097 6.52464 1.27522 7.28773 1.58993 7.98602C1.90464 8.68431 2.38079 9.29781 2.97915 9.77595L3.36975 10.0881L2.74549 10.8693L2.35488 10.5572C1.63273 9.98009 1.05806 9.23966 0.67824 8.3969C0.29842 7.55414 0.124326 6.63317 0.170308 5.70992C0.216289 4.78666 0.48103 3.88756 0.942709 3.0867C1.40439 2.28585 2.04978 1.60618 2.8257 1.10372C3.60162 0.601266 4.48584 0.290403 5.40548 0.196758Z",
    fill: "#414141"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13585_2548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmbientSound);
export default __webpack_public_path__ + "static/media/ambientSound.09809bc49857d43341c1d56ea6c450b8.svg";
export { ForwardRef as ReactComponent };